import { createListenerMiddleware } from "@reduxjs/toolkit";
import { apiSlice } from "@features/application/api-slice";
import { applicationSlice } from "@features/application/app-slice";

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: applicationSlice.actions.logout,
  effect: async (_, listenerApi) => {
    listenerApi.dispatch(apiSlice.util.resetApiState());
  },
});

export { listenerMiddleware };
